import { gql } from '@apollo/client';

export const VERDICT_TEMPLATES = gql`
  query verdictTemplates {
    verdictTemplates {
      key
      verdict
      reportReason
      headline
      body
    }
  }
`;
